import { render } from "./playerComponent.vue?vue&type=template&id=d4edf882&scoped=true"
import script from "./playerComponent.vue?vue&type=script&lang=js"
export * from "./playerComponent.vue?vue&type=script&lang=js"

import "./playerComponent.vue?vue&type=style&index=0&id=d4edf882&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4edf882"]])

export default __exports__